export default __webpack_public_path__ + "static/media/Background_00163.127c9e64.png";